import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("p", {
  class: "alert alert-danger",
  "data-cy": "PayPortal.NotFound.Alert"
}, "We couldn't find information about this content.", -1)
const _hoisted_2 = { "data-cy": "PayPortal.NotFound.Heading" }
const _hoisted_3 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { "data-cy": "PayPortal.NotFound.TryAgain" }, [
  /*#__PURE__*/_createTextVNode(" Sorry for the inconvenience! "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" Please give us a day to fix our data, and then try again. ")
], -1)




export default _defineComponent({
  expose: [],
  props: {
    className: { type: String, required: true }
  } as unknown as undefined,
  setup(__props: {
	className: string
}) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("h1", _hoisted_2, _toDisplayString(__props.className), 1),
    _hoisted_3,
    _hoisted_4
  ], 64))
}
}

})